module.exports = __webpack_public_path__ + "static/media/too-many-background2.73a08907.jpg";